import type { DependencyList, EffectCallback } from 'react'
import { useEffect } from 'react'

import { useIsFirstRender } from './useIsFirstRender'

/**
 * Just modified version of useEffect that is skipping the first render.
 * Credits: https://usehooks-ts.com/react-hook/use-update-effect
 *
 * @param effect Imperative function that can return a cleanup function
 * @param deps If present, effect will only activate if the values in the list change.
 */
export const useUpdateEffect = (
  effect: EffectCallback,
  deps?: DependencyList
) => {
  const isFirst = useIsFirstRender()

  useEffect(() => {
    if (!isFirst) {
      return effect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
